import React, { Component } from "react";
import { Line } from "react-chartjs-2";

class Chart extends Component {
    constructor(props) {
        super(props);

    }
    createChart(){
        return  <Line data={this.props.chartData}
                // width={100}
                height={450}
                options={{
                    maintainAspectRatio: false
                }}
    />
    }


    render() {
        return (
            <div className="chart">
                {this.createChart()}
            </div>
        )
    }
}

export default Chart;


// WEBPACK FOOTER //
// ./src/views/Chartjs/ChartData.jsx